import { Td, Tr, Typography } from '@aloft/toolkit-sui';

import { selectAdditionalStructureCostNew } from '../../../redux/features/selectors/selectCostNew.ts';
import { useAppSelector } from '../../../redux/hooks.ts';
import { getCostString } from '../utils/getCostString.ts';

export const AdditionalStructuresCostRow = () => {
  const cost = useAppSelector((state) => selectAdditionalStructureCostNew(state, 'subject'));

  return (
    <Tr>
      <Td>
        <Typography variant="body1">Additional Structures</Typography>
      </Td>
      <Td colSpan={8} className="cost-approach-table-align-right">
        {getCostString(cost)}
      </Td>
    </Tr>
  );
};
